import { Box, Group, Text } from '@mantine/core'
import { secondsToHHM } from '@/utils/datetime'
import { useTranslation } from 'react-i18next'

export function VehicleStats({ estimatedTime, drivenTime }: { estimatedTime: number; drivenTime: number }) {
  const { t } = useTranslation('scheduling')
  if (drivenTime === 0 && estimatedTime === 0) {
    return null
  }

  return (
    <Box>
      <Group justify="space-between">
        <Text size="sm" c="light-dark(var(--mantine-color-gray-7), #c9c9c9)">
          {t('estimated')}:{' '}
        </Text>
        <Text size="sm" fw={700}>
          {secondsToHHM(estimatedTime)}
        </Text>
      </Group>
      <Group justify="space-between">
        <Text size="sm" c="light-dark(var(--mantine-color-gray-7), #c9c9c9)">
          {t('driven')}:{' '}
        </Text>
        <Text size="sm" fw={700}>
          {secondsToHHM(drivenTime)}
        </Text>
      </Group>
    </Box>
  )
}
